export default __webpack_public_path__ + "static/media/Farming.55d49d9c.png";